module.exports = __webpack_public_path__ + "img/image11.3eb58674.png";